import React, { useContext } from "react";
import PropTypes from "prop-types";
import cc from "classcat";
import { twMerge } from "tailwind-merge";
import { ModalContext } from "./Modal";
ModalActions.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    centered: PropTypes.bool
};
export default function ModalActions(param) {
    var children = param.children, className = param.className, _centered = param.centered;
    var centered = useContext(ModalContext).centered;
    var isCentered = _centered !== undefined ? _centered : centered;
    return /*#__PURE__*/ React.createElement("div", {
        className: twMerge(cc([
            "rounded-b-md flex w-full items-center bg-white px-8 py-4 dark:border-gray-700 dark:bg-blue-800",
            {
                "justify-end gap-x-2 border-t py-5": !isCentered
            },
            {
                "justify-center gap-y-4 gap-x-2": isCentered
            },
            className
        ]))
    }, children);
}
